import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  LIST_SHEDULE_INIT,
  CREATE_SHEDULE_INIT,
  UPDATE_SHEDULE_INIT,
  DELETE_SHEDULE_INIT
} from '../../actionTypes';
import {
  listSheduleSuccess,
  createSheduleSuccess,
  updateSheduleSuccess,
  deleteSheduleSuccess,
  errorShedule
} from './actions';
import {
  listarShedules,
  criarShedule,
  excluirShedule,
  editarShedule
} from 'src/integracoes/servicos/pgloader/funcoes/schedule';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { ISchedule } from 'src/integracoes/servicos/pgloader/modelos/ISchedule';

// --------------------------- Listar shedules ---------------------------------------------------------

const fetchListarShedules = async (empId: string) => {
  try {
    const { status, dados, mensagem } = await listarShedules(empId);
    if (status && Array.isArray(dados)) {
      return { isError: false, shedules: dados, errorMessage: null };
    }
    return { isError: true, shedules: [], errorMessage: mensagem || 'Erro ao listar agendamentos' };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarShedules({ payload }: any) {
  try {
    const { isError, shedules, errorMessage } = yield call(fetchListarShedules, payload);
    if (!isError) {
      yield put(listSheduleSuccess(shedules));
    } else {
      yield put(errorShedule({ msg: errorMessage }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorShedule({ msg: mensagem }));
  }
}

function* watchListarShedules() {
  yield takeEvery(LIST_SHEDULE_INIT, parseListarShedules);
}

/* ------------------Criar shedule ---------------- */
const fetchCriarShedule = async (shedule: ISchedule) => {
  try {
    const { status, dados, mensagem } = await criarShedule(shedule);
    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarShedule({ payload }: { payload: any; type: any }) {
  const { shedule } = payload;

  try {
    const { isCreated, msg, data } = yield call(fetchCriarShedule, shedule);
    if (isCreated) {
      yield put(createSheduleSuccess({ isCreated, shedule: data, msg: msg }));
    } else {
      yield put(errorShedule({ msg }));
    }
  } catch (error: any) {
    yield put(
      errorShedule({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`
      })
    );
  }
}

function* watchCriarShedule() {
  yield takeEvery(CREATE_SHEDULE_INIT, parseCriarShedule);
}

/* ------------------Editar shedule ---------------- */
const fetchEditarShedule = async (id: string, shedule: ISchedule) => {
  try {
    const { status, mensagem } = await editarShedule(id, shedule);
    if (status) {
      return { isUpdated: true, msg: mensagem };
    } else {
      return {
        isUpdated: false,
        msg: mensagem
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseEditarShedule({ payload }: { payload: any; type: any }) {
  const { id, shedule } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchEditarShedule, id, shedule);

    if (isUpdated) {
      yield put(
        updateSheduleSuccess({
          isUpdated,
          msg,
          id
        })
      );
    } else {
      yield put(errorShedule({ msg }));
    }
  } catch (error: any) {
    yield put(
      errorShedule({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`
      })
    );
  }
}

function* watchEditarShedule() {
  yield takeEvery(UPDATE_SHEDULE_INIT, parseEditarShedule);
}

/* ------------------Deletar shedule ---------------- */
const fetchDeletarShedule = async (id: string, userId: string, email: string) => {
  try {
    const { status, mensagem } = await excluirShedule(id, userId, email);
    if (status) {
      return { isDeleted: true, msg: mensagem };
    } else {
      return {
        isDeleted: false,
        msg: mensagem
      };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDeletarShedule({ payload }: { payload: any; type: any }) {
  const { id, userId, email } = payload;
  try {
    const { isDeleted, msg } = yield call(fetchDeletarShedule, id, userId, email);

    if (isDeleted) {
      yield put(
        deleteSheduleSuccess({
          isDeleted,
          msg,
          id
        })
      );
    } else {
      yield put(errorShedule({ msg }));
    }
  } catch (error: any) {
    yield put(
      errorShedule({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`
      })
    );
  }
}

function* watchDeletarShedule() {
  yield takeEvery(DELETE_SHEDULE_INIT, parseDeletarShedule);
}

export default function* sheduleSaga() {
  yield all([
    fork(watchListarShedules),
    fork(watchCriarShedule),
    fork(watchEditarShedule),
    fork(watchDeletarShedule)
  ]);
}
